import { FC } from 'react';
import { Message, Edit } from 'tedooo-web-design-system/icons';
import { Button } from 'tedooo-web-design-system/ui';

import { translations } from 'translations/en';
import FollowButton from 'components/followButton/FollowButton';
import { checkSmallScreen } from 'utils';

interface IButtons {
  isLoggedInUser: boolean;
  isFollowing: boolean;
  onFollowToggle(): void;
  onEdit(): void;
  onMessageClick(): void;
}

const isSmallScreen = checkSmallScreen();

const Buttons: FC<IButtons> = ({
  onFollowToggle,
  isFollowing,
  isLoggedInUser,
  onEdit,
  onMessageClick,
}) => {
  if (isLoggedInUser) {
    return (
      <div className="buttons">
        <Button
          size="medium"
          isFullWidth={isSmallScreen}
          borderRadius="small"
          type="secondary"
          prefixIcon={<Edit />}
          text={translations.COMMON.EDIT}
          onClick={onEdit}
        />
      </div>
    );
  }

  const messageButtonType = isFollowing ? 'primary' : 'secondary';

  return (
    <div className="buttons">
      <FollowButton
        isFullWidth={isSmallScreen}
        isFollowing={isFollowing}
        onFollowToggle={onFollowToggle}
      />
      <Button
        borderRadius="small"
        isFullWidth={isSmallScreen}
        type={messageButtonType}
        size="medium"
        prefixIcon={<Message />}
        text={translations.COMMON.MESSAGE}
        onClick={onMessageClick}
      />
    </div>
  );
};

export default Buttons;
